import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface BonusClosingSectionProps {
  orderBump1Selected: boolean;
  setOrderBump1Selected: (value: boolean) => void;
  orderBump2Selected: boolean;
  setOrderBump2Selected: (value: boolean) => void;
}
export function BonusClosingSection({
  orderBump1Selected,
  setOrderBump1Selected,
  orderBump2Selected,
  setOrderBump2Selected
}: BonusClosingSectionProps) {
  const basePrice = 6;
  const orderBump1Price = 9;
  const orderBump2Price = 9;
  const totalPrice = basePrice + (orderBump1Selected ? orderBump1Price : 0) + (orderBump2Selected ? orderBump2Price : 0);
  const handlePurchaseClick = () => {
    trackInitiateCheckout();
  };
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto text-center" data-id="element-40">
      <div className="space-y-8" data-id="element-41">
        <div className="font-mono text-2xl md:text-3xl font-bold space-y-2" data-id="element-42">
          <p className="text-gray-400 line-through decoration-red-500/50" data-id="element-43">
            $188 USD en valor.
          </p>
          <p className="text-[#f0c674] text-glow transition-all duration-300" data-id="element-44">
            <span className="line-through decoration-red-500/50 text-gray-500 mr-3" data-id="element-45">
              $47 USD
            </span>{' '}
            ${totalPrice} USD hoy.
          </p>
        </div>

        <div className="font-sans text-lg text-gray-300 space-y-4 max-w-2xl mx-auto" data-id="element-46">
          <p data-id="element-47">Los bonos son tuyos desde el momento en que accedés.</p>
          <p data-id="element-48">
            Sin esperar. Sin cumplir condiciones. Sin "disponibles en 7 días".
          </p>
          <p className="font-medium text-gray-100 transition-all duration-300" data-id="element-49">
            Todo junto, todo ahora, todo por ${totalPrice}.
          </p>
        </div>

        <div className="py-8 border-y border-gray-800 my-12" data-id="element-50">
          <h3 className="font-serif text-2xl font-bold text-[#f0c674] mb-6 transition-all duration-300" data-id="element-51">
            ¿Por qué ${totalPrice} USD?
          </h3>
          <div className="font-sans text-gray-400 space-y-4 text-left md:text-center" data-id="element-52">
            <p data-id="element-53">
              Porque no quiero que el precio sea la razón por la que seguís
              operando de la misma manera el mes que viene.
            </p>
            <p data-id="element-54">
              Quiero que lo implementes. Quiero que funcione. Y quiero que
              cuando funcione, seas el ejemplo que le muestro al próximo.
            </p>
            <p className="font-medium text-gray-300 italic" data-id="element-55">
              Eso vale más para mí que cobrar $47.
            </p>
          </div>
        </div>

        <div className="max-w-md mx-auto pt-4" data-id="element-56">
          <Button fullWidth className="py-5 text-lg" href="https://www.jwmoka.shop/cart/46286948335787:1" onClick={handlePurchaseClick} data-id="element-57">
            ACCEDÉ AHORA POR $6 USD
          </Button>

          {/* Order Bumps */}
          <div className="mt-12 space-y-6" data-id="element-58">
            {/* Order Bump #1 */}
            <div className="border-2 border-[#d4a853]/40 bg-[#111827]/60 rounded-sm p-6 text-left hover:border-[#d4a853]/70 transition-colors animate-subtle-flash hover:animate-none relative" data-id="element-59">
              <div className="absolute -top-3 left-6 bg-[#d4a853] px-4 py-1 rounded-sm" data-id="element-60">
                <span className="font-mono text-xs font-bold text-[#0a0a0a] uppercase tracking-wider" data-id="element-61">
                  Altamente Recomendado
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-6" data-id="element-62">
                <div className="md:w-1/3 flex-shrink-0" data-id="element-63">
                  <img src="https://cdn.magicpatterns.com/uploads/7SuDVGv5nBDxGL4ahZwGqb/ChatGPT_Image_26_mar_2026,_00_48_33.png" alt="El Protocolo de Voz Humana" className="w-full h-auto rounded-sm border border-[#d4a853]/20" data-id="element-64" />
                </div>
                <div className="md:w-2/3 space-y-4" data-id="element-65">
                  <h4 className="font-serif text-xl md:text-2xl font-bold text-[#f0c674]" data-id="element-66">
                    ¿Querés que tu IA hable, piense y venda exactamente como
                    vos? 🧬
                  </h4>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed" data-id="element-67">
                    No dejes que tus clientes sientan que están hablando con un
                    robot frío y genérico. El 90% de las automatizaciones fallan
                    porque suenan a "manual corporativo". Con{' '}
                    <strong className="text-[#d4a853]" data-id="element-68">
                      El Protocolo de Voz Humana
                    </strong>
                    , vas a recibir el Prompt Maestro para clonar tu identidad
                    digital en ChatGPT o Claude.
                  </p>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed" data-id="element-69">
                    Aprendé a configurar tu "doble digital" para que redacte
                    correos, responda DMs y cree propuestas con tu propio ritmo,
                    tus muletillas y tu autoridad. Llevate hoy la guía de 12
                    slides por solo $9.00 y blindá tu marca personal.
                  </p>
                  <button onClick={() => setOrderBump1Selected(!orderBump1Selected)} className={`w-full flex items-center justify-center space-x-3 border-2 transition-all py-4 px-6 rounded-sm group ${orderBump1Selected ? 'bg-[#d4a853]/20 border-[#d4a853]' : 'bg-[#0a0a0a] border-[#d4a853]/50 hover:border-[#d4a853] hover:bg-[#d4a853]/10'}`} data-id="element-70">
                    <div className={`w-6 h-6 border-2 border-[#d4a853] rounded-sm flex items-center justify-center transition-colors ${orderBump1Selected ? 'bg-[#d4a853]' : 'group-hover:bg-[#d4a853]'}`} data-id="element-71">
                      <svg className={`w-4 h-4 text-[#0a0a0a] transition-opacity ${orderBump1Selected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-72">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-73" />
                      </svg>
                    </div>
                    <span className="font-mono font-bold text-[#f0c674] text-sm tracking-wider uppercase" data-id="element-74">
                      SÍ, QUIERO CLONAR MI VOZ (Solo $9.00)
                    </span>
                  </button>
                </div>
              </div>
            </div>

            {/* Order Bump #2 */}
            <div className="border-2 border-[#d4a853]/40 bg-[#111827]/60 rounded-sm p-6 text-left hover:border-[#d4a853]/70 transition-colors animate-subtle-flash hover:animate-none relative" style={{
            animationDelay: '1.5s'
          }} data-id="element-75">
              <div className="absolute -top-3 left-6 bg-[#d4a853] px-4 py-1 rounded-sm" data-id="element-76">
                <span className="font-mono text-xs font-bold text-[#0a0a0a] uppercase tracking-wider" data-id="element-77">
                  Altamente Recomendado
                </span>
              </div>
              <div className="flex flex-col md:flex-row gap-6" data-id="element-78">
                <div className="md:w-1/3 flex-shrink-0" data-id="element-79">
                  <img src="https://cdn.magicpatterns.com/uploads/vSGz6EPVduD4PoMtnAtJuH/ChatGPT_Image_26_mar_2026,_00_47_06.png" alt="El Ritual de la Desconexión" className="w-full h-auto rounded-sm border border-[#d4a853]/20" data-id="element-80" />
                </div>
                <div className="md:w-2/3 space-y-4" data-id="element-81">
                  <h4 className="font-serif text-xl md:text-2xl font-bold text-[#f0c674]" data-id="element-82">
                    ¿Te animás a apagar el celular este fin de semana sin perder
                    un solo cliente? 🏔️
                  </h4>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed" data-id="element-83">
                    La libertad no es facturar mucho, es poder desaparecer 48
                    horas sin que tu negocio se prenda fuego.{' '}
                    <strong className="text-[#d4a853]" data-id="element-84">
                      El Ritual de la Desconexión
                    </strong>{' '}
                    es el protocolo operativo que usan los dueños de negocio de
                    alto rendimiento para blindar su paz mental de viernes a
                    lunes.
                  </p>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed" data-id="element-85">
                    Te entrego la checklist exacta de "Cierre de Viernes", los
                    scripts de autorrespuesta de lujo que generan respeto (no
                    excusas) y el sistema de filtros para que solo te
                    interrumpan si hay una emergencia real. Recuperá tus fines
                    de semana hoy por solo $9.00.
                  </p>
                  <button onClick={() => setOrderBump2Selected(!orderBump2Selected)} className={`w-full flex items-center justify-center space-x-3 border-2 transition-all py-4 px-6 rounded-sm group ${orderBump2Selected ? 'bg-[#d4a853]/20 border-[#d4a853]' : 'bg-[#0a0a0a] border-[#d4a853]/50 hover:border-[#d4a853] hover:bg-[#d4a853]/10'}`} data-id="element-86">
                    <div className={`w-6 h-6 border-2 border-[#d4a853] rounded-sm flex items-center justify-center transition-colors ${orderBump2Selected ? 'bg-[#d4a853]' : 'group-hover:bg-[#d4a853]'}`} data-id="element-87">
                      <svg className={`w-4 h-4 text-[#0a0a0a] transition-opacity ${orderBump2Selected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-88">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-89" />
                      </svg>
                    </div>
                    <span className="font-mono font-bold text-[#f0c674] text-sm tracking-wider uppercase" data-id="element-90">
                      SÍ, QUIERO MI DESCONEXIÓN (Solo $9.00)
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 space-y-2" data-id="element-91">
            <p className="font-sans font-medium text-gray-300" data-id="element-92">
              Todo el programa + los 3 bonos incluidos
            </p>
            <p className="font-sans text-sm text-gray-500 flex items-center justify-center space-x-2" data-id="element-93">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500/50" data-id="element-94" />
              <span data-id="element-95">Acceso inmediato · Sin suscripción · Sin letra chica</span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}